import {
  typeEditUsersStateDataItem,
  typeUsersFilters,
} from "model/dashboardUsers/dUsersReducer";
import { apiClient } from "model/axiosConfig";
import { typeRequestPagination } from "model/system/constants";

// Type
export type typeUsersRequestFilters = {
  filters: {
    name?: string | string[] | null;
    storeId?: string | string[] | null;
    deleted?: boolean | null;
    position?: string | null | string[];
  };
  full: boolean;
  pageFilter?: typeRequestPagination;
  sortFilter?: {
    direction: string;
    column: string;
  };
};

// Get Users list
export const getUsersList = async (payload: {
  filters: typeUsersFilters;
  full?: boolean;
  paginationRequest?: typeRequestPagination;
}) => {
  const path = "user/user/search";
  const config = {
    headers: {},
  };
  const data: typeUsersRequestFilters = {
    filters: {},
    full: payload.full === undefined ? true : payload.full,
    pageFilter: payload.paginationRequest
      ? payload.paginationRequest
      : undefined,
    sortFilter: {
      direction: "ASC",
      column: "name",
    },
  };

  if (payload.filters.name) data.filters.name! = [payload.filters.name];
  if (payload.filters.storeId) data.filters.storeId = [payload.filters.storeId];
  if ("deleted" in payload.filters)
    data.filters.deleted = payload.filters.deleted;
  if (payload.filters.position)
    data.filters.position = payload.filters.position;

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    return error;
  }
};

//
// // Get User by name
export const getUserByName = async (payload: { userName: string }) => {
  const path = `/user/user/exists/name?name=${payload.userName}`;
  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    return error.response;
  }
};

// Change Users item
export const changeUsersItem = async (payload: {
  dataObject: typeEditUsersStateDataItem;
}) => {
  const path = "/user/user";
  const config = {
    headers: {},
  };
  const data = payload.dataObject;

  try {
    const response = await apiClient.patch(path, data, config);
    return response;
  } catch (error) {
    return error;
  }
};

// Add user
export const addUsersItem = async (payload: {
  dataObject: {
    firstName: string;
    lastName: string;
    position: string;
    email: string;
    phoneNumber: string;
    storeId: string | null;
    password: string;
    pin: string;
  };
}) => {
  const path =
    payload.dataObject.position === "ADMIN"
      ? "/user/management/register/merchant/admin"
      : "/user/management/register/merchant/user";
  const config = {
    headers: {},
  };

  const data = {
    credentials: [
      {
        value: payload.dataObject.password,
      },
    ],

    enabled: true,
    firstName: payload.dataObject.firstName,
    lastName: payload.dataObject.lastName,
    email: payload.dataObject.email,

    user: {
      email: payload.dataObject.email,
      phoneNumber: payload.dataObject.phoneNumber,
      pin: payload.dataObject.pin,
      position: payload.dataObject.position,
      storeId: payload.dataObject.storeId,
      name: `${payload.dataObject.firstName} ${payload.dataObject.lastName}`,
    },
  };

  try {
    const response = await apiClient.post(path, data, config);
    return response;
  } catch (error) {
    return error;
  }
};

// Check Email Exist

export const checkEmailExists = async (userEmail: string) => {
  const path = `user/user/${userEmail}/username`;

  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    return error;
  }
};
// Get users position
export const getUsersPositionList = async (payload: {}) => {
  const path = "/user/user/position";
  const config = {
    headers: {},
  };

  try {
    const response = await apiClient.get(path, config);
    return response;
  } catch (error) {
    return error;
  }
};

// Delete dashboardUsers item
export const deleteUsersItem = async (payload: { itemId: string }) => {
  const path = "/user/user/" + payload.itemId;
  const config = {
    headers: {},
  };

  try {
    const response = await apiClient.delete(path, config);
    return response;
  } catch (error) {
    return error;
  }
};

export const getUserById = async (id: string) => {
  const path = `/user/user/${id}`;
  const config = {
    headers: {},
  };

  try {
    return await apiClient.get(path, config);
  } catch (error) {
    return error;
  }
};

// Recover item
export const bulkRecoverUsers = async (payload: { bulkIds: string[] }) => {
  const path = "/user/user/restore/bulk";
  const config = {
    headers: {},
  };
  const data = payload.bulkIds;

  try {
    const response = await apiClient.post(path, data, config);
    return response;
  } catch (error) {
    return error;
  }
};

// search by Name
export const searchUsersByName = async (payload: { name: string }) => {
  const path = "user/user/search";
  const config = {
    headers: {},
  };
  const data = {
    filters: {
      name: payload.name,
    },
  };

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    return error;
  }
};

// search by Name
export const searchUsersByEmail = async (payload: { email: string }) => {
  const path = "user/user/search";
  const config = {
    headers: {},
  };
  const data = {
    filters: {
      email: payload.email,
    },
  };

  try {
    return await apiClient.post(path, data, config);
  } catch (error) {
    return error;
  }
};

// change User Password
export const changePasswordUserItem = async (payload: {
  newPassword: string;
  emailUser: string;
}) => {
  const path = `/user/management/user/${payload.emailUser}/credentials`;
  const config = {
    headers: {},
  };
  const data = {
    value: payload.newPassword,
  };

  try {
    return await apiClient.patch(path, data, config);
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
